<template>
    <Window :id="'addChildSys'" :title="title" :size="'m'" ref="Window">
       <div class="mb05x_E">
       		<div v-if="myMode=='single'">
       			<div class="fs12x" :title="getLanguageStr('word197','设备名称')">{{getLanguageStr('word197','设备名称')}}</div>
       			<InputText v-model="plantName" class="mb2x" :placeholder="$t('fill3rd125',[getLanguageStr('word197'),'请输入设备名称'])" :clearBtn="true" ref="searchBox" name="editChildSysSearch"></InputText>
       		</div>
            <div v-if="type=='normal'&&selectChildSystem" class="fs12x" :title="getLanguageStr('word1785','所属系统')">{{getLanguageStr('word1785','所属系统')}}</div>
            <subordinate-system v-if="type=='normal'&&selectChildSystem" ref="subordinateSystem" :stationId="stationId" @Update="SelectSystemId"></subordinate-system>
        </div>
        <button slot="btmBtn" class="functionBtn" type="button" @click="confirm" >{{getLanguageStr('cmd84','保存')}}</button>
    </Window>
</template>
<script>
import Window from "@/components/common/ui/WindowForAlert.vue"
import InputText from "@/components/common/ui/InputText.vue"
import SubordinateSystem from '@/view/maintain/part/childSys/SubordinateSystem.vue'
import {getLanguageStr} from "@/util/language"

import * as historyApi from '@/api/maintain/plant/list'

export default {
    name:'EditChildSysDevice',
    components:{Window,InputText,SubordinateSystem},
    props:{
        type:{type:String,default:'normal'},//"normal","onlyName",部分设备若要改名，必须传systemId
        selectChildSystem:{type:Boolean,default:true}//是否可选择子系统
    },
    data(){
        return{
            myMode:'single',
            stationId:'',
            systemId:'',
            title:'',
            plantName:'',
            deviceId:'',
            selectStationId:'',
            selectIds:[],
        }
    },
    methods:{
        getLanguageStr,
          show(data){
            if(data.hasOwnProperty('selectIds')){
                this.selectIds=data.selectIds
                this.systemId=data.stationId
            }else{
                this.systemId=data.systemId
                this.plantName = data.plantName;
                this.deviceId = data.deviceId;
            }
            this.stationId = data.stationId;
            if(this.myMode=='single'){
                this.title=getLanguageStr('cmd8','编辑')
            }else{
                this.title=getLanguageStr('plant1','批量选择所属系统');
            }
            this.$refs.Window.show({
                title:this.title
            });
            if(this.type=="normal"&&this.selectChildSystem) this.$refs.subordinateSystem.init(this.stationId,this.systemId);
        },
        modeChange(mode){
            this.myMode=mode
        },
        hide(){
            this.$refs.Window.hide();
        },
        SelectSystemId(id){
            this.selectStationId=id
        },
        confirm(){
            this.$refs.Window.hide();
            let req
            if(this.myMode=='single'){
                if(this.type=='normal'){
                    req={
                        name:this.plantName,
                        systemId:this.selectStationId||this.systemId||undefined
                    }
                }else{
                    req={
                        name:this.plantName,
                        systemId:this.selectStationId||this.systemId||undefined
                    }
                }
                historyApi.apiReplaceDevice(this.stationId,this.deviceId,req).then(res=>{
                    this.$emit('editSuccess')
                },error=>{
                    !_.isEmpty(error) && this.$notify(error)
                })
            }else{
                req={
                    deviceIds:this.selectIds,
                    systemId:this.selectStationId
                }
                historyApi.PostDeviceBath(this.stationId,req).then(res=>{
                this.$emit('editSuccess')
                },error=>{
                    !_.isEmpty(error) && this.$notify(error)
                })
            }
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/EditChildSysDevice.vue